import { c as _c } from "react/compiler-runtime";
import type { ICustomImageAsset } from "@filmweb/sanity-types";
import { DocType_Filmomtale, type FilmomtaleIdentifiableType } from "src/lib/types/Filmomtale";
import cssPosterStyles from "src/components/posterrow/CSSPoster.module.css";
import PlaySvg from 'src/components/svg/PlaySvg';
import styles from "./TrailerPoster.module.css";
import classNames from "classnames";
import CmsImageForAssetRef from "src/components/images/CmsImageForAssetRef";
import type { ITrailer } from "src/lib/types/Trailer";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import { getUrlForDoctype } from "src/lib/types/sanity";
import type { SanityDocument } from "sanity";

//#region [Props]
type YoutubeTrailerPosterProps = {
  trailer: ITrailer;
  image?: ICustomImageAsset | null;
  film: FilmomtaleIdentifiableType & {
    title?: string;
  };
  className?: string;
};
//#endregion

//#region [Component]
export default function YoutubeTrailerPoster(t0) {
  const $ = _c(28);
  const {
    trailer,
    image,
    film,
    className
  } = t0;
  let movieUrl;
  let t1;
  if ($[0] !== className || $[1] !== film || $[2] !== trailer.youtubeId) {
    const theme = getThemeStyles(styles);
    let t2;
    if ($[5] !== film || $[6] !== trailer.youtubeId) {
      t2 = film ? getUrlForDoctype(DocType_Filmomtale, undefined, undefined, film as unknown as SanityDocument) ?? `#trailer${trailer.youtubeId}` : `#trailer${trailer.youtubeId}`;
      $[5] = film;
      $[6] = trailer.youtubeId;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    movieUrl = t2;
    t1 = classNames(className, cssPosterStyles.CSSPoster, styles.SArticle, theme);
    $[0] = className;
    $[1] = film;
    $[2] = trailer.youtubeId;
    $[3] = movieUrl;
    $[4] = t1;
  } else {
    movieUrl = $[3];
    t1 = $[4];
  }
  let t2;
  if ($[8] !== className) {
    t2 = classNames(className, cssPosterStyles.CSSPosterWrapper, cssPosterStyles.CSSPosterMissing);
    $[8] = className;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const t3 = `#trailer${trailer.youtubeId}`;
  const t4 = !!film ? `Trailer for '${film.title}'` : undefined;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PlaySvg className={styles.SPlaySvg} />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== image || $[12] !== trailer.title) {
    t6 = image && <CmsImageForAssetRef assetRef={image._id} alt={trailer.title} isPosterAspect={true} />;
    $[11] = image;
    $[12] = trailer.title;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t6) {
    t7 = <a className={cssPosterStyles.CSSPosterSizer} href={t3} aria-label={t4}>{t5}{t6}</a>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t2 || $[19] !== t7) {
    t8 = <div className={t2}>{t7}</div>;
    $[18] = t2;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = film?.title ?? trailer.title;
  let t10;
  if ($[21] !== movieUrl || $[22] !== t9) {
    t10 = <h2 className={cssPosterStyles.H}><a href={movieUrl}>{t9}</a></h2>;
    $[21] = movieUrl;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t1 || $[25] !== t10 || $[26] !== t8) {
    t11 = <article className={t1}>{t8}{t10}</article>;
    $[24] = t1;
    $[25] = t10;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}
//#endregion